var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export * from "./types";
import { getUniqueFields, getUniqueActions } from "./utils";
export { getUniqueFields, getUniqueActions };
/**
 * Aliased to preserve backwards compatibility.
 *
 * @deprecated Use `getUniqueFields` instead.
 */
export const schemaToFields = getUniqueFields;
export const defaultGallery = {
    iterationResults: 1,
    inspirationResults: 3,
    minimumSimilarity: 0.4
};
export const defaultFlags = {
    "show-immediately": true
};
const defaultOptions = {
    endpoint: "https://components.glide.info/"
};
export const cleanFieldWithID = ({ id, name, type }) => ({
    id,
    name,
    type
});
export const cleanAction = ({ title }) => ({
    title
});
export const cleanSuggestedAction = ({ title, type, id }) => ({
    title,
    type,
    id
});
export const cleanActionWithID = ({ title, id }) => ({
    title,
    id
});
export const cleanField = ({ name, type }) => ({
    name,
    type
});
export const cleanSuggestedField = ({ id, name, type, defaultValue }) => ({
    id,
    name,
    type,
    defaultValue
});
export function cleanPayload(payload) {
    var _a, _b, _c, _d;
    return Object.assign(Object.assign({}, payload), { 
        // Sometimes we are sent values from legacy implementations.
        // We strip those out immediately.
        fields: payload.fields.map(cleanField), environment: {
            fields: (_b = (_a = payload.environment) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.map(cleanFieldWithID),
            actions: (_d = (_c = payload.environment) === null || _c === void 0 ? void 0 : _c.actions) === null || _d === void 0 ? void 0 : _d.map(cleanActionWithID)
        } });
}
const currentRoutePsuedoEndpoint = "https://pseudo.com/";
class Client {
    constructor(options) {
        this.options = options;
    }
    route(path, searchParams = {}) {
        let { endpoint } = this.options;
        // If we have an empty endpoint, we're using the current endpoint
        // and we need to use a pseudo endpoint to use the URL class
        if (["", "/"].includes(endpoint)) {
            endpoint = currentRoutePsuedoEndpoint;
        }
        const url = new URL(endpoint);
        url.pathname = path;
        for (const [key, value] of Object.entries(searchParams)) {
            url.searchParams.set(key, value);
        }
        return url.toString().replace(currentRoutePsuedoEndpoint, "/");
    }
    get routeGenerate() {
        return this.route("/generate");
    }
    routeCommitInfo(id, opts) {
        return this.route(`/commit/${id}`, opts);
    }
    generate(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            payload = cleanPayload(payload);
            try {
                const response = yield this.fetch("POST", this.routeGenerate, payload);
                if (!response.ok) {
                    const { errorDisplay } = yield response.json();
                    return { ok: false, error: response.statusText, errorDisplay };
                }
                const component = yield response.json();
                return { ok: true, component };
            }
            catch (error) {
                const errorDisplay = JSON.stringify(error);
                return { ok: false, error: "Something went wrong", errorDisplay };
            }
        });
    }
    fetch(method_1, url_1) {
        return __awaiter(this, arguments, void 0, function* (method, url, body = undefined) {
            const response = yield fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: body === undefined ? undefined : JSON.stringify(body)
            });
            return response;
        });
    }
    getCommitInfo(id, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const x = yield this.fetch("GET", this.routeCommitInfo(id, opts));
            return yield x.json();
        });
    }
    generateTable(prompt) {
        return this.fetch("POST", this.route("/generate/table"), { prompt }).then(x => x.json());
    }
}
export const createClient = (opts = {}) => {
    return new Client(Object.assign(Object.assign({}, defaultOptions), opts));
};
